import { defineStore } from 'pinia';
import { useApiStore } from './api.js';
import { useUserStore } from './user.js';
import { ref, computed } from 'vue';

export const useProjectsStore = defineStore('projects', () => {
  const isProjectsLoading = ref(true);
  const projects = ref(null);

  const currentProjects = computed(() => {
    const userStore = useUserStore();
    const hiddenProjectUuids = userStore.hiddenProjects || [];
    return (
      projects.value
        ?.filter((project) =>
          project.status === 'listed' &&
          !hiddenProjectUuids.includes(project.uuid)
        )
        .sort((a, b) => new Date(b.modified) - new Date(a.modified)) ?? []
    );
  });

  const draftProjects = computed(() => {
    const userStore = useUserStore();
    const hiddenProjectUuids = userStore.hiddenProjects || [];
    return (
      projects.value
        ?.filter((project) =>
          project.status === 'draft' &&
          !hiddenProjectUuids.includes(project.uuid)
        )
        .sort((a, b) => new Date(b.modified) - new Date(a.modified)) ?? []
    );
  });

  const archivedProjects = computed(() => {
    const userStore = useUserStore();
    const hiddenProjectUuids = userStore.hiddenProjects || [];
    return (
      projects.value
        ?.filter((project) =>
          project.status === 'unlisted' &&
          !hiddenProjectUuids.includes(project.uuid)
        )
        .sort((a, b) => new Date(b.modified) - new Date(a.modified)) ?? []
    );
  });

  const api = useApiStore();
  api.fetchData('projects').then((json) => {
    // setTimeout(() => {
    isProjectsLoading.value = false;
    projects.value = json.page.children;
    // }, 3000);
  }).catch(() => {
    isProjectsLoading.value = false;
  });

  // Functions
  function getProjectByUuid(uuid) {
    const project = projects.value.find((project) => project.uuid === uuid);
    return project;
  }

  return {
    projects,
    currentProjects,
    archivedProjects,
    draftProjects,
    getProjectByUuid,
    isProjectsLoading,
  };
});
